<template>
  <b-modal
    id="modal-detail-historical-budget-task"
    size="xl"
    :title="`Historical Log Detail Budget Task- ${activity}`"
    @hide="resetModal()"
    @show="showModal()"
    hide-footer
  >
    <div class="container-fluid">
      <div v-if="isLoading" class="row mb-3">
        <!-- Skeleton loader, misalnya tampilkan placeholder -->
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <!-- Tambahkan skeleton untuk seluruh konten yang memerlukan data -->
      </div>

      <div v-else>
        <!-- Bagian Header -->
        <div class="card">
          <div class="card-body">
            <h4>Activity Description</h4>
            <p>{{ logData?.activity_description }}</p>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">Detail Budget Task</h4>
          </div>
          <div class="card-body">
            <div class="row row-cols-1 row-cols-md-4 g-4">
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Department</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.detailBudgetTask?.department_org_chart_name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Plan Title</h4>
                    <small class="text-body-secondary"
                      ><span>
                        {{
                          ` ${detail?.detailBudgetTask?.plan_title} version ${detail?.detailBudgetTask?.plan_version} ${detail?.detailBudgetTask?.plan_year}`
                        }}</span
                      >
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Type</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.detailBudgetTask?.budget_type }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">GL Name</h4>
                    <small class="text-body-secondary"
                      ><span> {{ ` ${detail?.detailBudgetTask?.gl_code} - ${detail?.detailBudgetTask?.account_name}` }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Task</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.detailBudgetTask?.name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Contract Name</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.contract_name || '-' }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-calendar"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">{{ titleCase(`${activity}d at`) }}</h4>
                    <small class="text-body-secondary"
                      ><span> {{ formatDate(logData?.created_at) }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-calendar"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">{{ titleCase(`${activity}d by`) }}</h4>
                    <small class="text-body-secondary"
                      ><span> {{ logData?.createdUser?.fullname }}</span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="logData?.activity == 'Update' && detail?.histories">
          <div class="card-header">Changes</div>
          <div class="card-body">
            <div class="card" v-if="planChanges?.length > 0">
              <div class="card-header">Budget Plan</div>
              <div class="card-body">
                <vsa-list style="max-width: 100% !important ; border: none">
                  <vsa-item v-for="(item, indexItem) in planChanges" :key="indexItem" class="mb-2 border border-warning">
                    <vsa-heading>
                      <div class="font-weight-bold">
                        <span class="badge bg-warning">Modified</span>
                        {{ item?.category && item.category.slice(0, 1).toUpperCase() + item.category.slice(1) }}
                      </div>
                    </vsa-heading>
                    <vsa-content>
                      <div class="row">
                        <div class="col-6"><span class="badge bg-primary mr-2">Old</span>{{ item.old }}</div>
                        <div class="col-6"><span class="badge bg-success mr-2">New</span>{{ item.new }}</div>
                      </div>
                    </vsa-content>
                  </vsa-item>
                </vsa-list>
              </div>
            </div>
            <b-tabs pills card fill>
              <b-tab :title="`OPEX`">
                <div class="card">
                  <div class="card-header">Transactions</div>
                  <div class="card-body">
                    <div class="row" v-if="opexChanges?.opexDiff?.length > 0">
                      <vsa-list style="max-width: 100% !important ; border: none">
                        <vsa-item
                          v-for="(transaction, indexTransaction) in opexChanges.opexDiff"
                          :key="indexTransaction"
                          :class="`mb-2 ${
                            transaction.type === 'deleted' || transaction.type === 'transfer_out'
                              ? 'border border-danger'
                              : transaction.type === 'added' || transaction.type === 'transfer_in'
                              ? 'border border-success'
                              : 'border border-warning'
                          }`"
                        >
                          <vsa-heading>
                            <div class="font-weight-bold">
                              <span v-if="transaction.type === 'deleted' || transaction.type === 'transfer_out'" class="badge bg-red">{{
                                transaction.type === 'deleted' ? 'Deleted' : 'Transfered'
                              }}</span>
                              <span v-else-if="transaction.type === 'added' || transaction.type === 'transfer_in'" class="badge bg-success">{{
                                transaction.type === 'added' ? 'Added' : 'Transfered'
                              }}</span>
                              <span v-else class="badge bg-warning">Modified</span>
                              {{
                                transaction.type === 'deleted' || transaction.type === 'transfer_out'
                                  ? transaction.old.account_name
                                  : transaction.new.account_name
                              }}
                            </div>
                          </vsa-heading>
                          <vsa-content>
                            <div class="mb-3 p-2" v-for="(item, indexItem) in transaction?.old?.items">
                              <span>Budget Item : {{ item.item_name }}</span>
                              <div style="overflow: auto">
                                <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                  <thead>
                                    <tr>
                                      <th style="width: 350px">Budget Task</th>
                                      <th style="width: 350px">Description</th>
                                      <th style="width: 150px">January</th>
                                      <th style="width: 150px">February</th>
                                      <th style="width: 150px">March</th>
                                      <th style="width: 150px">April</th>
                                      <th style="width: 150px">May</th>
                                      <th style="width: 150px">June</th>
                                      <th style="width: 150px">July</th>
                                      <th style="width: 150px">August</th>
                                      <th style="width: 150px">September</th>
                                      <th style="width: 150px">October</th>
                                      <th style="width: 150px">November</th>
                                      <th style="width: 150px">December</th>
                                      <th style="width: 150px">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(task, indx) in item?.tasks" :key="indx" class="opex">
                                      <td>{{ task.name }}</td>
                                      <td>{{ task.description }}</td>
                                      <td>{{ formatCurrency(task.jan) }}</td>
                                      <td>{{ formatCurrency(task.feb) }}</td>
                                      <td>{{ formatCurrency(task.mar) }}</td>
                                      <td>{{ formatCurrency(task.apr) }}</td>
                                      <td>{{ formatCurrency(task.may) }}</td>
                                      <td>{{ formatCurrency(task.jun) }}</td>
                                      <td>{{ formatCurrency(task.jul) }}</td>
                                      <td>{{ formatCurrency(task.aug) }}</td>
                                      <td>{{ formatCurrency(task.sep) }}</td>
                                      <td>{{ formatCurrency(task.oct) }}</td>
                                      <td>{{ formatCurrency(task.nov) }}</td>
                                      <td>{{ formatCurrency(task.dec) }}</td>
                                      <td>{{ formatCurrency(task.total) }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div
                              :class="
                                transaction.type === 'deleted' || transaction.type === 'transfer_out'
                                  ? 'border border-danger mb-3 p-2'
                                  : 'border border-success mb-3 p-2'
                              "
                              v-for="(item, indexItem) in transaction?.new?.items"
                            >
                              <span>Budget Item : {{ item.item_name }}</span>
                              <div style="overflow: auto">
                                <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                  <thead>
                                    <tr>
                                      <th style="width: 350px">Budget Task</th>
                                      <th style="width: 350px">Description</th>
                                      <th style="width: 150px">January</th>
                                      <th style="width: 150px">February</th>
                                      <th style="width: 150px">March</th>
                                      <th style="width: 150px">April</th>
                                      <th style="width: 150px">May</th>
                                      <th style="width: 150px">June</th>
                                      <th style="width: 150px">July</th>
                                      <th style="width: 150px">August</th>
                                      <th style="width: 150px">September</th>
                                      <th style="width: 150px">October</th>
                                      <th style="width: 150px">November</th>
                                      <th style="width: 150px">December</th>
                                      <th style="width: 150px">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(task, indx) in item?.tasks" :key="indx" class="opex">
                                      <td>{{ task.name }}</td>
                                      <td>{{ task.description }}</td>
                                      <td>{{ formatCurrency(task.jan) }}</td>
                                      <td>{{ formatCurrency(task.feb) }}</td>
                                      <td>{{ formatCurrency(task.mar) }}</td>
                                      <td>{{ formatCurrency(task.apr) }}</td>
                                      <td>{{ formatCurrency(task.may) }}</td>
                                      <td>{{ formatCurrency(task.jun) }}</td>
                                      <td>{{ formatCurrency(task.jul) }}</td>
                                      <td>{{ formatCurrency(task.aug) }}</td>
                                      <td>{{ formatCurrency(task.sep) }}</td>
                                      <td>{{ formatCurrency(task.oct) }}</td>
                                      <td>{{ formatCurrency(task.nov) }}</td>
                                      <td>{{ formatCurrency(task.dec) }}</td>
                                      <td>{{ formatCurrency(task.total) }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </vsa-content>
                        </vsa-item>
                      </vsa-list>
                    </div>
                    <div class="row" v-else>
                      <div class="col-12 text-center text-info p-3">No Changes</div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">Budget Items</div>
                  <div class="card-body">
                    <div class="row" v-if="opexChanges?.opexItemDiff?.length > 0">
                      <vsa-list style="max-width: 100% !important; border: none">
                        <vsa-item
                          v-for="(item, indexItem) in opexChanges.opexItemDiff"
                          :key="indexItem"
                          :class="`mb-2 ${
                            item.type === 'deleted' || item.type === 'transfer_out'
                              ? 'border border-danger'
                              : item.type === 'added' || item.type === 'transfer_in'
                              ? 'border border-success'
                              : 'border border-warning'
                          }`"
                        >
                          <vsa-heading>
                            <div class="font-weight-bold">
                              <span v-if="item.type === 'deleted' || item.type === 'transfer_out'" class="badge bg-red">{{
                                item.type === 'deleted' ? 'Deleted' : 'Transfered'
                              }}</span>
                              <span v-else-if="item.type === 'added' || item.type === 'transfer_in'" class="badge bg-success">{{
                                item.type === 'added' ? 'Added' : 'Transfered'
                              }}</span>
                              <span v-else class="badge bg-warning">Modified</span>
                              {{
                                item.type === 'deleted' || item.type === 'transfer_out'
                                  ? `${item.old?.gl_code} | ${item.old?.item_name}`
                                  : `${item.new?.gl_code} | ${item.new?.item_name}`
                              }}
                            </div>
                          </vsa-heading>
                          <vsa-content>
                            <div class="mb-3 p-2">
                              <span>Transaction : {{ item.transaction_name }}</span>
                              <div style="overflow: auto">
                                <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                  <thead>
                                    <tr>
                                      <th style="width: 350px">Budget Task</th>
                                      <th style="width: 350px">Description</th>
                                      <th style="width: 150px">January</th>
                                      <th style="width: 150px">February</th>
                                      <th style="width: 150px">March</th>
                                      <th style="width: 150px">April</th>
                                      <th style="width: 150px">May</th>
                                      <th style="width: 150px">June</th>
                                      <th style="width: 150px">July</th>
                                      <th style="width: 150px">August</th>
                                      <th style="width: 150px">September</th>
                                      <th style="width: 150px">October</th>
                                      <th style="width: 150px">November</th>
                                      <th style="width: 150px">December</th>
                                      <th style="width: 150px">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody v-if="item.type === 'deleted' || item.type === 'transfer_out'">
                                    <tr v-for="(task, indx) in item.old?.tasks" :key="indx" class="opex">
                                      <td>{{ task.name }}</td>
                                      <td>{{ task.description }}</td>
                                      <td>{{ formatCurrency(task.jan) }}</td>
                                      <td>{{ formatCurrency(task.feb) }}</td>
                                      <td>{{ formatCurrency(task.mar) }}</td>
                                      <td>{{ formatCurrency(task.apr) }}</td>
                                      <td>{{ formatCurrency(task.may) }}</td>
                                      <td>{{ formatCurrency(task.jun) }}</td>
                                      <td>{{ formatCurrency(task.jul) }}</td>
                                      <td>{{ formatCurrency(task.aug) }}</td>
                                      <td>{{ formatCurrency(task.sep) }}</td>
                                      <td>{{ formatCurrency(task.oct) }}</td>
                                      <td>{{ formatCurrency(task.nov) }}</td>
                                      <td>{{ formatCurrency(task.dec) }}</td>
                                      <td>{{ formatCurrency(task.total) }}</td>
                                    </tr>
                                  </tbody>
                                  <tbody v-else>
                                    <tr v-for="(task, indx) in item.new?.tasks" :key="indx" class="opex">
                                      <td>{{ task.name }}</td>
                                      <td>{{ task.description }}</td>
                                      <td>{{ formatCurrency(task.jan) }}</td>
                                      <td>{{ formatCurrency(task.feb) }}</td>
                                      <td>{{ formatCurrency(task.mar) }}</td>
                                      <td>{{ formatCurrency(task.apr) }}</td>
                                      <td>{{ formatCurrency(task.may) }}</td>
                                      <td>{{ formatCurrency(task.jun) }}</td>
                                      <td>{{ formatCurrency(task.jul) }}</td>
                                      <td>{{ formatCurrency(task.aug) }}</td>
                                      <td>{{ formatCurrency(task.sep) }}</td>
                                      <td>{{ formatCurrency(task.oct) }}</td>
                                      <td>{{ formatCurrency(task.nov) }}</td>
                                      <td>{{ formatCurrency(task.dec) }}</td>
                                      <td>{{ formatCurrency(task.total) }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </vsa-content>
                        </vsa-item>
                      </vsa-list>
                    </div>
                    <div v-else class="row">
                      <div class="col-12 text-center text-info p-3">No Changes</div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">Budget Task</div>
                  <div class="card-body">
                    <div class="row" v-if="opexChanges?.opexTaskDiff?.length > 0">
                      <vsa-list style="max-width: 100% !important; border: none">
                        <vsa-item
                          v-for="(task, indexTask) in opexChanges.opexTaskDiff"
                          :key="indexTask"
                          :class="`mb-2 ${
                            task.type === 'deleted' || task.type === 'transfer_out'
                              ? 'border border-danger'
                              : task.type === 'added' || task.type === 'transfer_in'
                              ? 'border border-success'
                              : 'border border-warning'
                          }`"
                        >
                          <vsa-heading>
                            <div class="font-weight-bold">
                              <span v-if="task.type === 'deleted' || task.type === 'transfer_out'" class="badge bg-red">{{
                                task.type === 'deleted' ? 'Deleted' : 'Transfered'
                              }}</span>
                              <span v-else-if="task.type === 'added' || task.type === 'transfer_in'" class="badge bg-success">{{
                                task.type === 'added' ? 'Added' : 'Transfered'
                              }}</span>
                              <span v-else class="badge bg-warning">Modified</span>
                              {{ task.type === 'deleted' || task.type === 'transfer_out' ? `${task.old?.name}` : `${task.new?.name}` }}
                            </div>
                          </vsa-heading>
                          <vsa-content>
                            <div class="mb-3 p-2">
                              <span>Transaction : {{ task.transaction_name }}</span
                              ><br />
                              <span>Item : {{ task.item_name }}</span>
                              <div style="overflow: auto">
                                <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                  <thead>
                                    <tr>
                                      <th style="width: 350px">Budget Task</th>
                                      <th style="width: 350px">Description</th>
                                      <th style="width: 150px">January</th>
                                      <th style="width: 150px">February</th>
                                      <th style="width: 150px">March</th>
                                      <th style="width: 150px">April</th>
                                      <th style="width: 150px">May</th>
                                      <th style="width: 150px">June</th>
                                      <th style="width: 150px">July</th>
                                      <th style="width: 150px">August</th>
                                      <th style="width: 150px">September</th>
                                      <th style="width: 150px">October</th>
                                      <th style="width: 150px">November</th>
                                      <th style="width: 150px">December</th>
                                      <th style="width: 150px">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="opex" v-if="task.type === 'deleted' || task.type === 'transfer_out'">
                                      <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                      <td>{{ task.old?.description }}</td>
                                      <td>{{ formatCurrency(task.old?.jan) }}</td>
                                      <td>{{ formatCurrency(task.old?.feb) }}</td>
                                      <td>{{ formatCurrency(task.old?.mar) }}</td>
                                      <td>{{ formatCurrency(task.old?.apr) }}</td>
                                      <td>{{ formatCurrency(task.old?.may) }}</td>
                                      <td>{{ formatCurrency(task.old?.jun) }}</td>
                                      <td>{{ formatCurrency(task.old?.jul) }}</td>
                                      <td>{{ formatCurrency(task.old?.aug) }}</td>
                                      <td>{{ formatCurrency(task.old?.sep) }}</td>
                                      <td>{{ formatCurrency(task.old?.oct) }}</td>
                                      <td>{{ formatCurrency(task.old?.nov) }}</td>
                                      <td>{{ formatCurrency(task.old?.dec) }}</td>
                                      <td>{{ formatCurrency(task.old?.total) }}</td>
                                    </tr>
                                    <tr class="opex" v-if="task.type === 'added' || task.type === 'transfer_in'">
                                      <td><span class="badge bg-green mr-2">New</span>{{ task.new?.name }}</td>
                                      <td>{{ task.new?.description }}</td>
                                      <td>{{ formatCurrency(task.new?.jan) }}</td>
                                      <td>{{ formatCurrency(task.new?.feb) }}</td>
                                      <td>{{ formatCurrency(task.new?.mar) }}</td>
                                      <td>{{ formatCurrency(task.new?.apr) }}</td>
                                      <td>{{ formatCurrency(task.new?.may) }}</td>
                                      <td>{{ formatCurrency(task.new?.jun) }}</td>
                                      <td>{{ formatCurrency(task.new?.jul) }}</td>
                                      <td>{{ formatCurrency(task.new?.aug) }}</td>
                                      <td>{{ formatCurrency(task.new?.sep) }}</td>
                                      <td>{{ formatCurrency(task.new?.oct) }}</td>
                                      <td>{{ formatCurrency(task.new?.nov) }}</td>
                                      <td>{{ formatCurrency(task.new?.dec) }}</td>
                                      <td>{{ formatCurrency(task.new?.total) }}</td>
                                    </tr>
                                    <tr class="opex" v-if="task.type === 'modified'">
                                      <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                      <td>{{ task.old?.description }}</td>
                                      <td>{{ formatCurrency(task.old?.jan) }}</td>
                                      <td>{{ formatCurrency(task.old?.feb) }}</td>
                                      <td>{{ formatCurrency(task.old?.mar) }}</td>
                                      <td>{{ formatCurrency(task.old?.apr) }}</td>
                                      <td>{{ formatCurrency(task.old?.may) }}</td>
                                      <td>{{ formatCurrency(task.old?.jun) }}</td>
                                      <td>{{ formatCurrency(task.old?.jul) }}</td>
                                      <td>{{ formatCurrency(task.old?.aug) }}</td>
                                      <td>{{ formatCurrency(task.old?.sep) }}</td>
                                      <td>{{ formatCurrency(task.old?.oct) }}</td>
                                      <td>{{ formatCurrency(task.old?.nov) }}</td>
                                      <td>{{ formatCurrency(task.old?.dec) }}</td>
                                      <td>{{ formatCurrency(task.old?.total) }}</td>
                                    </tr>
                                    <tr class="opex" v-if="task.type === 'modified'">
                                      <td :class="`${task.new?.name !== task.old?.name ? 'td-green' : ''}`">
                                        <span class="badge bg-green mr-2">New</span>{{ task.new?.name }}
                                      </td>
                                      <td :class="`${task.new?.description !== task.old?.description ? 'td-green' : ''}`">
                                        {{ task.new?.description }}
                                      </td>
                                      <td :class="`${task.new?.jan !== task.old?.jan ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jan) }}</td>
                                      <td :class="`${task.new?.feb !== task.old?.feb ? 'td-green' : ''}`">{{ formatCurrency(task.new?.feb) }}</td>
                                      <td :class="`${task.new?.mar !== task.old?.mar ? 'td-green' : ''}`">{{ formatCurrency(task.new?.mar) }}</td>
                                      <td :class="`${task.new?.apr !== task.old?.apr ? 'td-green' : ''}`">{{ formatCurrency(task.new?.apr) }}</td>
                                      <td :class="`${task.new?.may !== task.old?.may ? 'td-green' : ''}`">{{ formatCurrency(task.new?.may) }}</td>
                                      <td :class="`${task.new?.jun !== task.old?.jun ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jun) }}</td>
                                      <td :class="`${task.new?.jul !== task.old?.jul ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jul) }}</td>
                                      <td :class="`${task.new?.aug !== task.old?.aug ? 'td-green' : ''}`">{{ formatCurrency(task.new?.aug) }}</td>
                                      <td :class="`${task.new?.sep !== task.old?.sep ? 'td-green' : ''}`">{{ formatCurrency(task.new?.sep) }}</td>
                                      <td :class="`${task.new?.oct !== task.old?.oct ? 'td-green' : ''}`">{{ formatCurrency(task.new?.oct) }}</td>
                                      <td :class="`${task.new?.nov !== task.old?.nov ? 'td-green' : ''}`">{{ formatCurrency(task.new?.nov) }}</td>
                                      <td :class="`${task.new?.dec !== task.old?.dec ? 'td-green' : ''}`">{{ formatCurrency(task.new?.dec) }}</td>
                                      <td :class="`${task.new?.total !== task.old?.total ? 'td-green' : ''}`">
                                        {{ formatCurrency(task.new?.total) }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </vsa-content>
                        </vsa-item>
                      </vsa-list>
                    </div>
                    <div v-else class="row">
                      <div class="col-12 text-center text-info p-3">No Changes</div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab :title="`CAPEX`">
                <div class="card">
                  <div class="card-header">Budget Items</div>
                  <div class="card-body">
                    <div class="row" v-if="capexChanges?.capexDiff?.length > 0">
                      <vsa-list style="max-width: 100% !important; border: none">
                        <vsa-item
                          v-for="(item, indexItem) in capexChanges.capexDiff"
                          :key="indexItem"
                          :class="`mb-2 ${
                            item.type === 'deleted'
                              ? 'border border-danger'
                              : item.type === 'modified'
                              ? 'border border-warning'
                              : 'border border-success'
                          }`"
                        >
                          <vsa-heading>
                            <div class="font-weight-bold">
                              <span v-if="item.type === 'deleted'" class="badge bg-red">Deleted</span>
                              <span v-else class="badge bg-green">Added</span>
                              {{
                                item.type === 'deleted'
                                  ? `${item.old?.fund || ''} - ${item.old?.account_name}`
                                  : `${item.new?.fund || ''} - ${item.new?.account_name}`
                              }}
                            </div>
                          </vsa-heading>
                          <vsa-content>
                            <div class="mb-3 p-2">
                              <div style="overflow: auto">
                                <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                  <thead>
                                    <tr>
                                      <th style="width: 350px">Budget Task</th>
                                      <th style="width: 350px">Description</th>
                                      <th style="width: 150px">January</th>
                                      <th style="width: 150px">February</th>
                                      <th style="width: 150px">March</th>
                                      <th style="width: 150px">April</th>
                                      <th style="width: 150px">May</th>
                                      <th style="width: 150px">June</th>
                                      <th style="width: 150px">July</th>
                                      <th style="width: 150px">August</th>
                                      <th style="width: 150px">September</th>
                                      <th style="width: 150px">October</th>
                                      <th style="width: 150px">November</th>
                                      <th style="width: 150px">December</th>
                                      <th style="width: 150px">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody v-if="item.type === 'deleted'">
                                    <tr v-for="(task, indx) in item.old?.tasks" :key="indx" class="opex">
                                      <td>{{ task.name }}</td>
                                      <td>{{ task.description }}</td>
                                      <td>{{ formatCurrency(task.jan) }}</td>
                                      <td>{{ formatCurrency(task.feb) }}</td>
                                      <td>{{ formatCurrency(task.mar) }}</td>
                                      <td>{{ formatCurrency(task.apr) }}</td>
                                      <td>{{ formatCurrency(task.may) }}</td>
                                      <td>{{ formatCurrency(task.jun) }}</td>
                                      <td>{{ formatCurrency(task.jul) }}</td>
                                      <td>{{ formatCurrency(task.aug) }}</td>
                                      <td>{{ formatCurrency(task.sep) }}</td>
                                      <td>{{ formatCurrency(task.oct) }}</td>
                                      <td>{{ formatCurrency(task.nov) }}</td>
                                      <td>{{ formatCurrency(task.dec) }}</td>
                                      <td>{{ formatCurrency(task.total) }}</td>
                                    </tr>
                                  </tbody>
                                  <tbody v-else>
                                    <tr v-for="(task, indx) in item.new?.tasks" :key="indx" class="opex">
                                      <td>{{ task.name }}</td>
                                      <td>{{ task.description }}</td>
                                      <td>{{ formatCurrency(task.jan) }}</td>
                                      <td>{{ formatCurrency(task.feb) }}</td>
                                      <td>{{ formatCurrency(task.mar) }}</td>
                                      <td>{{ formatCurrency(task.apr) }}</td>
                                      <td>{{ formatCurrency(task.may) }}</td>
                                      <td>{{ formatCurrency(task.jun) }}</td>
                                      <td>{{ formatCurrency(task.jul) }}</td>
                                      <td>{{ formatCurrency(task.aug) }}</td>
                                      <td>{{ formatCurrency(task.sep) }}</td>
                                      <td>{{ formatCurrency(task.oct) }}</td>
                                      <td>{{ formatCurrency(task.nov) }}</td>
                                      <td>{{ formatCurrency(task.dec) }}</td>
                                      <td>{{ formatCurrency(task.total) }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </vsa-content>
                        </vsa-item>
                      </vsa-list>
                    </div>
                    <div v-else class="row">
                      <div class="col-12 text-center text-info p-3">No Changes</div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">Budget Task</div>
                  <div class="card-body">
                    <div class="row" v-if="capexChanges?.capexTaskDiff?.length > 0">
                      <vsa-list style="max-width: 100% !important; border: none">
                        <vsa-item
                          v-for="(task, indexTask) in capexChanges.capexTaskDiff"
                          :key="indexTask"
                          :class="`mb-2 ${
                            task.type === 'deleted'
                              ? 'border border-danger'
                              : task.type === 'modified'
                              ? 'border border-warning'
                              : 'border border-success'
                          }`"
                        >
                          <vsa-heading>
                            <div class="font-weight-bold">
                              <span :class="`badge ${task.type === 'deleted' ? 'bg-red' : task.type === 'modified' ? 'bg-yellow' : 'bg-green'}`">{{
                                task.type === 'deleted' ? 'Deleted' : task.type === 'modified' ? 'Modified' : 'Added'
                              }}</span>
                              {{ task.type === 'deleted' ? `${task.old?.name}` : `${task.new?.name}` }}
                            </div>
                          </vsa-heading>
                          <vsa-content>
                            <div class="mb-3 p-2">
                              <span>Item : {{ task.item_name }}</span>
                              <div style="overflow: auto">
                                <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                  <thead>
                                    <tr>
                                      <th style="width: 350px">Budget Task</th>
                                      <th style="width: 350px">Description</th>
                                      <th style="width: 150px">January</th>
                                      <th style="width: 150px">February</th>
                                      <th style="width: 150px">March</th>
                                      <th style="width: 150px">April</th>
                                      <th style="width: 150px">May</th>
                                      <th style="width: 150px">June</th>
                                      <th style="width: 150px">July</th>
                                      <th style="width: 150px">August</th>
                                      <th style="width: 150px">September</th>
                                      <th style="width: 150px">October</th>
                                      <th style="width: 150px">November</th>
                                      <th style="width: 150px">December</th>
                                      <th style="width: 150px">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="opex" v-if="task.type === 'deleted'">
                                      <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                      <td>{{ task.old?.description }}</td>
                                      <td>{{ formatCurrency(task.old?.jan) }}</td>
                                      <td>{{ formatCurrency(task.old?.feb) }}</td>
                                      <td>{{ formatCurrency(task.old?.mar) }}</td>
                                      <td>{{ formatCurrency(task.old?.apr) }}</td>
                                      <td>{{ formatCurrency(task.old?.may) }}</td>
                                      <td>{{ formatCurrency(task.old?.jun) }}</td>
                                      <td>{{ formatCurrency(task.old?.jul) }}</td>
                                      <td>{{ formatCurrency(task.old?.aug) }}</td>
                                      <td>{{ formatCurrency(task.old?.sep) }}</td>
                                      <td>{{ formatCurrency(task.old?.oct) }}</td>
                                      <td>{{ formatCurrency(task.old?.nov) }}</td>
                                      <td>{{ formatCurrency(task.old?.dec) }}</td>
                                      <td>{{ formatCurrency(task.old?.total) }}</td>
                                    </tr>
                                    <tr class="opex" v-if="task.type === 'added'">
                                      <td><span class="badge bg-green mr-2">New</span>{{ task.new?.name }}</td>
                                      <td>{{ task.new?.description }}</td>
                                      <td>{{ formatCurrency(task.new?.jan) }}</td>
                                      <td>{{ formatCurrency(task.new?.feb) }}</td>
                                      <td>{{ formatCurrency(task.new?.mar) }}</td>
                                      <td>{{ formatCurrency(task.new?.apr) }}</td>
                                      <td>{{ formatCurrency(task.new?.may) }}</td>
                                      <td>{{ formatCurrency(task.new?.jun) }}</td>
                                      <td>{{ formatCurrency(task.new?.jul) }}</td>
                                      <td>{{ formatCurrency(task.new?.aug) }}</td>
                                      <td>{{ formatCurrency(task.new?.sep) }}</td>
                                      <td>{{ formatCurrency(task.new?.oct) }}</td>
                                      <td>{{ formatCurrency(task.new?.nov) }}</td>
                                      <td>{{ formatCurrency(task.new?.dec) }}</td>
                                      <td>{{ formatCurrency(task.new?.total) }}</td>
                                    </tr>
                                    <tr class="opex" v-if="task.type === 'modified'">
                                      <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                      <td>{{ task.old?.description }}</td>
                                      <td>{{ formatCurrency(task.old?.jan) }}</td>
                                      <td>{{ formatCurrency(task.old?.feb) }}</td>
                                      <td>{{ formatCurrency(task.old?.mar) }}</td>
                                      <td>{{ formatCurrency(task.old?.apr) }}</td>
                                      <td>{{ formatCurrency(task.old?.may) }}</td>
                                      <td>{{ formatCurrency(task.old?.jun) }}</td>
                                      <td>{{ formatCurrency(task.old?.jul) }}</td>
                                      <td>{{ formatCurrency(task.old?.aug) }}</td>
                                      <td>{{ formatCurrency(task.old?.sep) }}</td>
                                      <td>{{ formatCurrency(task.old?.oct) }}</td>
                                      <td>{{ formatCurrency(task.old?.nov) }}</td>
                                      <td>{{ formatCurrency(task.old?.dec) }}</td>
                                      <td>{{ formatCurrency(task.old?.total) }}</td>
                                    </tr>
                                    <tr class="opex" v-if="task.type === 'modified'">
                                      <td :class="`${task.new?.name !== task.old?.name ? 'td-green' : ''}`">
                                        <span class="badge bg-green mr-2">New</span>{{ task.new?.name }}
                                      </td>
                                      <td :class="`${task.new?.description !== task.old?.description ? 'td-green' : ''}`">
                                        {{ task.new?.description }}
                                      </td>
                                      <td :class="`${task.new?.jan !== task.old?.jan ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jan) }}</td>
                                      <td :class="`${task.new?.feb !== task.old?.feb ? 'td-green' : ''}`">{{ formatCurrency(task.new?.feb) }}</td>
                                      <td :class="`${task.new?.mar !== task.old?.mar ? 'td-green' : ''}`">{{ formatCurrency(task.new?.mar) }}</td>
                                      <td :class="`${task.new?.apr !== task.old?.apr ? 'td-green' : ''}`">{{ formatCurrency(task.new?.apr) }}</td>
                                      <td :class="`${task.new?.may !== task.old?.may ? 'td-green' : ''}`">{{ formatCurrency(task.new?.may) }}</td>
                                      <td :class="`${task.new?.jun !== task.old?.jun ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jun) }}</td>
                                      <td :class="`${task.new?.jul !== task.old?.jul ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jul) }}</td>
                                      <td :class="`${task.new?.aug !== task.old?.aug ? 'td-green' : ''}`">{{ formatCurrency(task.new?.aug) }}</td>
                                      <td :class="`${task.new?.sep !== task.old?.sep ? 'td-green' : ''}`">{{ formatCurrency(task.new?.sep) }}</td>
                                      <td :class="`${task.new?.oct !== task.old?.oct ? 'td-green' : ''}`">{{ formatCurrency(task.new?.oct) }}</td>
                                      <td :class="`${task.new?.nov !== task.old?.nov ? 'td-green' : ''}`">{{ formatCurrency(task.new?.nov) }}</td>
                                      <td :class="`${task.new?.dec !== task.old?.dec ? 'td-green' : ''}`">{{ formatCurrency(task.new?.dec) }}</td>
                                      <td :class="`${task.new?.total !== task.old?.total ? 'td-green' : ''}`">
                                        {{ formatCurrency(task.new?.total) }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </vsa-content>
                        </vsa-item>
                      </vsa-list>
                    </div>
                    <div v-else class="row">
                      <div class="col-12 text-center text-info p-3">No Changes</div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <div class="card" v-if="logData?.activity == 'Update' && !detail?.histories">
          <div class="card-header">
            <h4 class="card-header-title">Detail Changes</h4>
          </div>
          <div class="card-body">
            <div v-for="(field, key) in comparisonData" :key="key" class="row align-items-center mb-2">
              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-warning p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>Old Data</strong>
                    </div>
                    <div class="mb-3 text-primary p-3 py-1 rounded fs-4">
                      <strong>{{ key }}</strong>
                    </div>
                  </div>
                  <p class="mb-0">{{ field.old_value }}</p>
                </div>
              </div>

              <div class="col-md-2 text-center">
                <i class="fe fe-arrow-right fs-3 text-primary"></i>
              </div>

              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-info p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>New Data</strong>
                    </div>
                    <div class="mb-3 text-primary p-3 py-1 rounded fs-4">
                      <strong>{{ key }}</strong>
                    </div>
                  </div>
                  <p class="mb-0">{{ field.new_value }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axiosIns from '@/api/axios';
import { formatCurrency } from '@/utils/formatNumber';
import moment from 'moment';
import { VsaList, VsaItem, VsaHeading, VsaContent, VsaIcon } from 'vue-simple-accordion';

export default {
  props: {
    logId: Number,
    activity: String,
  },
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
  },
  computed: {
    detail() {
      return this.logData?.oldData;
    },
    changes() {
      return this.detail?.histories?.[0]?.changes?.groupedChanges || {};
    },
    opexChanges() {
      return {
        opexDiff: this.changes?.opexDiff || [],
        opexItemDiff: this.changes?.opexItemDiff || [],
        opexTaskDiff: this.changes?.opexTaskDiff || [],
      };
    },
    capexChanges() {
      return {
        capexDiff: this.changes?.capexDiff || [],
        capexTaskDiff: this.changes?.capexTaskDiff || [],
      };
    },
    planChanges() {
      return this.changes?.planDiff || [];
    },
  },
  data() {
    return {
      isLoading: true, // To show skeleton loader
      logData: {}, // To store the log data from API
      comparisonData: {}, // Store comparison of old and new values
    };
  },
  methods: {
    async showModal() {
      await this.fetchHistoricalLog();
    },
    resetModal() {
      this.logData = {}; // Reset the log data
      this.comparisonData = {}; // Reset the comparison data
      this.isLoading = true; // Reset loading state
    },
    async fetchHistoricalLog() {
      if (!this.logId) return;
      this.resetModal();
      await axiosIns
        .get(`/historical-log/${this.logId}`)
        .then((response) => {
          const data = response.data.data;
          this.logData = data.detail;
          this.logData.data_changes = data.data_changes;
          this.comparisonData = this.getComparisonData(data.data_changes.old_value, data.data_changes.new_value);
          this.isLoading = false; // Set loading state to false when data is fetched
        })
        .catch((error) => {
          this.isLoading = true; // Stop loading if error occurs
          this.$swal('Error', error.response?.data?.error || 'Terjadi kesalahan, tidak dapat mengambil data.', 'error');
          this.resetModal();
          console.error('Error fetching historical log details:', error);
        });
    },
    formatDate(date, withTime = true) {
      if (withTime) {
        return date ? moment(date).format('DD MMMM YYYY HH:mm') : '-';
      }
      return date ? moment(date).format('DD MMMM YYYY') : '-';
    },
    formatCurrency(value) {
      return formatCurrency(value, 'Rp.') || '-';
    },
    getComparisonData(old_value, new_value) {
      // Memastikan old_value dan new_value bukan undefined atau null
      const oldValue = old_value || {};
      const newValue = new_value || {};

      const filterKeysMapping = (keys) => {
        return keys
          .filter(
            (key) =>
              !key.includes('id') && !key.includes('code_plan_budget') && !key.includes('code_actual_budget') && !key.includes('actual_budget_item')
          )
          .map((key) => {
            let transformedKey = key;
            if (transformedKey.includes('subject')) {
              transformedKey = transformedKey.replace(/subject/gi, 'number');
            }
            transformedKey = transformedKey.replace(/(po|pr|im|gl)/gi, (match) => match.toUpperCase());
            return {
              original: key,
              transformed: transformedKey,
            };
          });
      };

      // Contoh pemakaian di kode pembanding data:
      const result = {};
      const oldMappings = filterKeysMapping(Object.keys(oldValue));
      const newMappings = filterKeysMapping(Object.keys(newValue));

      // Iterasi key dari oldValue
      oldMappings.forEach((mapping) => {
        const formattedKey = this.formatKey(mapping.transformed);
        result[formattedKey] = {
          old_value: oldValue[mapping.original] || '-',
          new_value: newValue[mapping.original] || '-',
        };
      });

      // Tambahkan key yang ada di newValue tapi tidak di oldValue
      newMappings.forEach((mapping) => {
        const formattedKey = this.formatKey(mapping.transformed);
        if (!result.hasOwnProperty(formattedKey)) {
          result[formattedKey] = {
            old_value: oldValue[mapping.original] || '-',
            new_value: newValue[mapping.original] || '-',
          };
        }
      });

      return result;
    },
    // Fungsi untuk mengubah key (mengganti "_" menjadi spasi dan kapitalisasi setiap kata)
    formatKey(key) {
      return key
        .replace(/_/g, ' ') // Ganti _ dengan spasi
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Kapitalisasi setiap awal kata
    },
    titleCase(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>

<style>
.skeleton-loader {
  background-color: #e0e0e0;
  height: 20px;
  margin-bottom: 10px;
  border-radius: 4px;
}
</style>
